import { isBrowser } from '../is-browser';

export const getLatestLFEvent = async (
  params?: Record<string, any>,
  headers?: HeadersInit,
) => {
  const queryParams = new URLSearchParams({
    action: 'livliFamilyEvent',
    ...params,
  }).toString();
  const url = `/api/app-wrapper?${queryParams}`;

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...(headers || {}),
    },
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw {
      status: response.status,
      message: errorData?.errorMessage || 'Failed to fetch content',
      raw: errorData,
    };
  }

  return response.json();
};

export const getEventSlotsData = async (
  params?: Record<string, any>,
  headers?: HeadersInit,
  baseUrl?: string,
) => {
  const queryParams = new URLSearchParams({
    ...params,
  }).toString();

  const base = baseUrl || '';
  const url =
    base && base.length > 0
      ? `${base}/api/slots?${queryParams}`
      : `/api/slots?${queryParams}`;

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw {
      status: response.status,
      message: errorData?.errorMessage || 'Failed to fetch content',
      raw: errorData,
    };
  }

  return response.json();
};
